import React, { useEffect, useState } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Autocomplete,
  Divider as MuiDivider,
  Box,
  TextField,
  MenuItem,
  Card,
} from "@mui/material";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";

import Switch from "@mui/material/Switch";
import { useStyles } from "../../../../../Styles/style";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const AttributesModal = ({
  allAttributes,
  item,
  setItemsArr,
  itemsArr,

  filteredItemsArr,
  handleChangeAttributeValue,
  index,
  setSelectedItem,
  selectedItem,
  handleChangeURL,
  handleChangeEnum,
  handleChangeSwitch,
  isLoading,
  removeAttribute,
  handleChangeRepeatedEnum,
  enumRequired,
  setEnumRequired,
  urlRequired,
  setUrlRequired,
  repeatedEnumRequired,
  setRepeatedEnumRequired,
  urlValidation,
  setUrlValidation,
  handleRepeatedEnumSwitch,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    setSelectedItem(item);
  }, []);

  var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

  var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
  var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
  function validURLOther(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  }

  function validURL(string) {
    if (typeof string !== "string") {
      return false;
    }

    var match = string.match(protocolAndDomainRE);
    if (!match) {
      return false;
    }

    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
      return false;
    }

    if (
      localhostDomainRE.test(everythingAfterProtocol) ||
      nonLocalhostDomainRE.test(everythingAfterProtocol)
    ) {
      return true;
    }

    return false;
  }

  function handleDisplayName(name) {
    let text = "";
    if (name !== "" && name !== undefined) {
      const splittedText = name.split("/");

      const finalText = splittedText[1]?.replaceAll("_", " ");
      text =
        finalText[0]?.toUpperCase() + finalText?.substring(1)?.toLowerCase();
    }

    return text;
  }

  return (
    <>
      <>
        <Grid container spacing={2} sx={{ marginTop: "12px" }}>
          <Grid
            item
            xs={7}
            sm={7}
            md={item?.valueType === "BOOL" ? 10 : 6}
            lg={item?.valueType === "BOOL" ? 10 : 6}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={filteredItemsArr?.length > 0 ? filteredItemsArr : []}
              value={item}
              onChange={(e, value) => {
                handleChangeAttributeValue(value, index, item);
              }}
              getOptionLabel={(option) =>
                option?.displayName
                  ? option?.displayName
                  : handleDisplayName(option?.internalName)
              }
              fullWidth
              renderInput={(params) => (
                <TextField placeholder={t("select_attr")} {...params} />
              )}
            />
          </Grid>
          {item?.valueType !== "BOOL" && (
            <Grid item xs={4} sm={4} md={4} lg={4}>
              {item?.valueType === "URL" ? (
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: { marginLeft: "4px" },
                    },
                  }}
                  name="locationName"
                  placeholder={t("Enter_URl")}
                  required
                  value={
                    item?.uriValues?.length > 0 ? item?.uriValues[0]?.uri : ""
                  }
                  onChange={(e) => {
                    handleChangeURL(e, item, index);
                    if (e.target.value.length > 0) {
                      setUrlRequired(false);

                      const occurrences = (
                        e.target.value.match(/https?/g) || []
                      ).length;
                      const wwwOccurrences =
                        e.target.value.split("www").length - 1;
                      const invalidCharacters = /[<>]/;
                      const validity =
                        validURL(e.target.value) ||
                        validURLOther(e.target.value);

                      if (invalidCharacters.test(e.target.value)) {
                        setUrlValidation(true);
                      } else if (occurrences === 2) {
                        setUrlValidation(true);
                      } else if (wwwOccurrences >= 2) {
                        setUrlValidation(true);
                      } else if (!validity) {
                        setUrlValidation(true);
                      } else if (invalidCharacters.test(e.target.value)) {
                        setUrlValidation(true);
                      } else {
                        setUrlValidation(false);
                      }
                    } else {
                      setUrlRequired(true);
                    }
                  }}
                  error={item?.errorRequired || item?.error}
                  helperText={
                    (item?.errorRequired && t("URL_is_Required")) ||
                    (item?.error && t("Invalid_Url"))
                  }
                />
              ) : item?.valueType === "ENUM" ? (
                <>
                  <TextField
                    style={{ width: "100%" }}
                    onChange={(e, value) => {
                      handleChangeEnum(e.target.value, item, index);
                      if (value === null) {
                        setEnumRequired(true);
                      } else {
                        setEnumRequired(false);
                      }
                    }}
                    select
                    label={`${t("Select")} ${item?.displayName}`}
                    error={item?.enumRequired}
                    helperText={item?.enumRequired && t("Field_is_Required")}
                    value={
                      item?.values?.length > 0
                        ? item?.values[0] === false || item?.values[0] === true
                          ? ""
                          : item?.values[0]
                        : ""
                    }
                  >
                    {item?.valueMetadata?.length > 0 &&
                      item?.valueMetadata?.map((item, index) => (
                        <MenuItem key={index} value={item?.value}>
                          {item?.displayName}
                        </MenuItem>
                      ))}
                  </TextField>
                </>
              ) : (
                item?.valueType === "REPEATED_ENUM" && (
                  <>
                    <Card
                      variant="outlined"
                      sx={{ borderColor: "#bfbfbf", borderRadius: "4px" }}
                    >
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          sx={{ borderRadius: "8px" }}
                        >
                          <Typography>{item?.displayName}</Typography>
                          <Divider />
                        </AccordionSummary>

                        <AccordionDetails>
                          {item?.valueMetadata?.length > 0 &&
                            item?.valueMetadata?.map((itemOne, ind) => (
                              <Grid container key={ind}>
                                <Grid
                                  item
                                  xs={8}
                                  sm={8}
                                  lg={8}
                                  md={8}
                                  sx={{ paddingTop: "8px" }}
                                >
                                  <Typography
                                    className={
                                      item?.repeatedEnumValue?.setValues?.includes(
                                        itemOne
                                      ) === true ||
                                      item?.repeatedEnumValue?.unsetValues?.includes(
                                        itemOne
                                      ) === true
                                        ? classes.selectedAttributes
                                        : classes.unSelectedAttributes
                                    }
                                  >
                                    {itemOne?.displayName}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} lg={4} md={4}>
                                  <Box sx={{ display: "flex" }}>
                                    <Switch
                                      className={
                                        item?.repeatedEnumValue?.setValues?.includes(
                                          itemOne
                                        ) === true
                                          ? classes.toggleUnChecked
                                          : classes.toggleChecked
                                      }
                                      checked={item?.repeatedEnumValue?.setValues?.includes(
                                        itemOne
                                      )}
                                      onChange={(e) =>
                                        handleRepeatedEnumSwitch(
                                          e,
                                          itemOne,
                                          index,
                                          ind
                                        )
                                      }
                                    />
                                    <Typography sx={{ paddingTop: "8px" }}>
                                      {" "}
                                      {item?.repeatedEnumValue?.setValues?.includes(
                                        itemOne
                                      ) === true
                                        ? t("Yes")
                                        : t("No")}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            ))}
                        </AccordionDetails>
                      </Accordion>
                    </Card>
                  </>
                )
              )}
            </Grid>
          )}
          <Grid xs={1.5} sm={1.5} md={1} lg={1} sx={{ display: "flex" }}>
            {item?.valueType === "BOOL" && (
              <Box sx={{ display: "flex", paddingTop: "10px" }}>
                <Switch
                  className={
                    item?.values?.length > 0 && item?.values[0] === true
                      ? classes.toggleUnChecked
                      : classes.toggleChecked
                  }
                  checked={
                    item?.values?.length > 0 && item?.values[0] === true
                      ? true
                      : false
                  }
                  onChange={(e) => handleChangeSwitch(e, index)}
                />
                <Typography sx={{ paddingTop: "8px" }}>
                  {" "}
                  {item?.values?.length > 0 && item?.values[0] === true
                    ? t("Yes")
                    : t("No")}
                </Typography>
              </Box>
            )}
          </Grid>

          <Grid item xs={1} sm={1} md={1} lg={1} sx={{ textAlign: "end" }}>
            <IconButton onClick={() => removeAttribute(index)}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </>
    </>
  );
};

export default AttributesModal;
